import React, { forwardRef, useRef } from 'react';
import { space } from 'styled-system';
import { maestroComponent } from '../../utils/componentHelpers.es.js';
import styled from 'styled-components';
import '../../utils/responsive.es.js';
import { useLockBodyScroll } from '../../hooks/useLockBodyScroll/useLockBodyScroll.es.js';
import '../../hooks/useNotification/useNotification.es.js';
import '../../hooks/useToast/useToast.es.js';
import { useOnClickOutside } from '../../hooks/useOnClickOutside/useOnClickOutside.es.js';
import '@popperjs/core';
import '../../utils/assertions.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import 'react-beautiful-dnd';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledDialog = styled("div").attrs({ role: "dialog" })`
    ${space};
`;
const DialogComponent = forwardRef((_a, ref) => {
  var _b = _a, { lockBodyScroll, onClickOutside } = _b, props = __objRest(_b, ["lockBodyScroll", "onClickOutside"]);
  const wrappedRef = useRef(ref);
  useLockBodyScroll(lockBodyScroll, wrappedRef);
  if (onClickOutside) {
    useOnClickOutside(wrappedRef, onClickOutside);
  }
  return /* @__PURE__ */ React.createElement(StyledDialog, __spreadProps(__spreadValues({}, props), {
    ref: wrappedRef
  }));
});
const Dialog = maestroComponent("Dialog", DialogComponent);
Dialog.defaultProps = {
  lockBodyScroll: false
};

export { Dialog };
//# sourceMappingURL=Dialog.es.js.map
